import { useEffect, useState } from 'react';
import { obtenerUsuariosConsultantesPorFiltro,deshabilitarFichaConsultante} from '../data/FichaConsultante';
import { useContext } from "react";
import { AuthContext } from "auth";



export const useListarUsuariosConsultantes = () => {
    var {user,logout}= useContext(AuthContext);
    
    const [usuariosConsultantes, setUsuariosConsultantes] = useState([]);
    const [disable, setDisable] = useState(false);
    
    const getUsuariosConsultantes = async(filtro) => {
        
        const usuarios = await obtenerUsuariosConsultantesPorFiltro(filtro,user.Token);
        setUsuariosConsultantes(usuarios);
    }

    const disabledFichaConsultante=async(Id) =>{
        if(Id!=undefined && Id!=''){
            const respuesta=await deshabilitarFichaConsultante(Id,user.Token);
            setDisable(true)
            return respuesta;
        }
    }
    
    useEffect( () => {
        async function setListarUsuarios(){
            getUsuariosConsultantes();
        }
        setListarUsuarios();
        
    }, []);
    useEffect( () => {
        if(disable){
            
            async function setListarUsuarios(){
                getUsuariosConsultantes();
            }
            setListarUsuarios();
            setDisable(false)

        }
        

        
    }, [disable]);
    
    return {
        usuariosConsultantes,
        getUsuariosConsultantes,
        disabledFichaConsultante
        
    }

}
